import { Component, OnInit, AfterViewChecked } from '@angular/core';
declare var $: any;

@Component({
  selector: 'display-table-with-flags',
  templateUrl: './display-table-with-flags.component.html',
  styleUrls: ['./display-table-with-flags.component.css']
})

export class DisplayTableWithFlagsComponent implements OnInit, AfterViewChecked {

  private dataTable: any;
  private dtTable: any;
  private dtOptions: any;
  private copySheetTable: object[] = [];
  private copyTableHeader: string[] = [];

  constructor() { }

  ngOnInit() {
    this.dataTable = $('#importFilesWithFlags');
  }

  ngAfterViewChecked() {
    this.addTooltip();
  }

  public show(copySheetTable: object[], copyTableHeader: string[]) {
    this.copySheetTable = copySheetTable;
    this.copyTableHeader = copyTableHeader;

    this.createTable();
  }

  private createTable() {

    this.dtOptions = {
      data: this.copySheetTable,
      columns: this.copyTableHeader.map(x => ({ name: x })),
      index: false,
      select: false,
      filter: false,
      orderBy: false,
      exportButtons: [],
      autoColumnTitle: true
    }

    this.destroyDtable();
    this.dtTable = this.dataTable.LinkTable(this.dtOptions);
  }

  private addTooltip() {
    $('[data-toggle="tooltip"]').tooltip();
  }

  public destroyDtable() {
    if (this.dtTable) {
      this.dtTable.Destroy();
      this.dtTable = null;
    }
  }
}
